import React, {createContext, useCallback, useContext, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {sideMenuBroughtToFront} from '../redux/actions';

export const SIDE_MENU_IDS = {
  PLAYERS_LIST: 'players-list',
  POLICY_MARKET: 'policy-market',
  // Статы игрока — от плиты ресурсов в шапке (PlayerStatsDropdown)
  PLAYER_STATS: 'player-stats',
};

const SideMenuStackContext = createContext(null);

export const SideMenuStackProvider = ({children}) => {
  // По умолчанию поверх списка игроков лежит рынок политик (открытыми
  // бывают обе панели сразу — тогда видна верхняя)
  const [topSideMenuId, setTopSideMenuId] = useState(SIDE_MENU_IDS.POLICY_MARKET);
  const dispatch = useDispatch();

  // Зеркалим верхнюю панель в стор — предикаты обучения контекст не видят
  useEffect(() => {
    dispatch(sideMenuBroughtToFront(topSideMenuId));
  }, [dispatch, topSideMenuId]);

  const bringSideMenuToFront = useCallback((sideMenuId) => {
    setTopSideMenuId(sideMenuId);
  }, []);

  // Какие панели сейчас выдвинуты — чтобы Esc закрывал верхнюю из открытых, а
  // не ту, что просто последней поднималась наверх (она могла уже закрыться,
  // а под ней остаться открытой другая)
  const [openSideMenuIds, setOpenSideMenuIds] = useState(() => new Set());
  const setSideMenuOpen = useCallback((sideMenuId, isOpen) => {
    setOpenSideMenuIds((previous) => {
      if (previous.has(sideMenuId) === isOpen) {
        return previous;
      }
      const next = new Set(previous);
      if (isOpen) {
        next.add(sideMenuId);
      } else {
        next.delete(sideMenuId);
      }
      return next;
    });
  }, []);
  const topOpenSideMenuId = openSideMenuIds.has(topSideMenuId)
    ? topSideMenuId
    : ([...openSideMenuIds][0] || null);

  return (
    <SideMenuStackContext.Provider value={{topSideMenuId, bringSideMenuToFront, topOpenSideMenuId, setSideMenuOpen}}>
      {children}
    </SideMenuStackContext.Provider>
  );
};

export const useSideMenuStack = () => {
  const context = useContext(SideMenuStackContext);
  if (!context) {
    throw new Error('useSideMenuStack must be used within a SideMenuStackProvider');
  }
  return context;
};
